import { Power2, gsap } from 'gsap';

import { gsapTimelineFunc } from '../gsap-config';

export const rotateInA: gsapTimelineFunc = (target) => {
  return gsap.timeline().fromTo(
    target,
    {
      duration: 0,
      opacity: 0,
      x: '-150%',
      rotateZ: -720,
      transformOrigin: '50% 50%',
      ease: Power2.easeOut,
    },
    {
      duration: 1,
      opacity: 1,
      x: 0,
      rotateZ: 0,
      transformOrigin: '50% 50%',
      ease: Power2.easeOut,
    }
  );
};
